/**
 * Build a Schema.org BreadcrumbList for a sub-page.
 *
 * Usage:
 *   const schema = buildBreadcrumbSchema([
 *     { name: t('nav.home'),   path: '/' },
 *     { name: t('nav.prices'), path: '/prices' },
 *   ]);
 *   <SEOHead ... schema={schema} />
 */
const BASE_URL = 'https://udent.com.ua';

export const buildBreadcrumbSchema = (items) => ({
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
        '@type': 'ListItem',
        position: idx + 1,
        name: item.name,
        item: `${BASE_URL}${item.path}`,
    })),
});

